"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var androidClose = exports.androidClose = { "viewBox": "0 0 512 512", "children": [{ "name": "g", "attribs": { "id": "Icon_5_" }, "children": [{ "name": "g", "attribs": {}, "children": [{ "name": "g", "attribs": {}, "children": [{ "name": "polygon", "attribs": { "points": "405,136.798 375.202,107 256,226.202 136.798,107 107,136.798 226.202,256 107,375.202 136.798,405 256,285.798 \r\n\t\t\t375.202,405 405,375.202 285.798,256 \t\t" }, "children": [{ "name": "polygon", "attribs": { "points": "405,136.798 375.202,107 256,226.202 136.798,107 107,136.798 226.202,256 107,375.202 136.798,405 256,285.798 \r\n\t\t\t375.202,405 405,375.202 285.798,256 \t\t" }, "children": [] }] }] }] }] }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/ionicons/androidClose.js
// module id = 198
// module chunks = 1